/*
 * Keeps every animated wave divider (snippets/wave-divider.liquid) scrolling at a
 * pixel-accurate rate. When a wave opts into marquee sync, its speed is matched to
 * the on-page marquee (sections/marquee.liquid) in px/second — not loop duration,
 * since the marquee's track is several viewports wide and would otherwise appear to
 * move much faster than a one-viewport wave. Falls back to the wave's own
 * data-speed (px/s) when sync is off or no marquee is present.
 */
(function () {
  if (window.__oddmiWaveSync) return;
  window.__oddmiWaveSync = true;

  function marqueePxPerSecond() {
    var track = document.querySelector('.oddmi-marquee__track');
    if (!track) return null;
    var duration = parseFloat(getComputedStyle(track).animationDuration);
    if (!duration) return null;
    // @keyframes oddmi-marquee-tick translates the track by -50% per cycle.
    var distance = track.getBoundingClientRect().width / 2;
    return distance / duration;
  }

  function sync() {
    var waves = document.querySelectorAll('.oddmi-wave--animated');
    if (!waves.length) return;
    var marqueeRate = marqueePxPerSecond();
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    waves.forEach(function (wave) {
      var travel = wave.getBoundingClientRect().width;
      if (!travel) return;

      // A narrow viewport spans far fewer pixels, so the same px/second finishes a
      // wave cycle much sooner and reads as "too fast". An explicit mobile speed
      // (data-speed-mobile > 0) takes priority on small screens, even over marquee sync.
      var mobileRate = Number(wave.dataset.speedMobile) || 0;

      var rate;
      if (isMobile && mobileRate) {
        rate = mobileRate;
      } else if (wave.dataset.syncMarquee === 'true' && marqueeRate) {
        rate = marqueeRate;
      } else {
        rate = Number(wave.dataset.speed) || 120;
      }

      wave.style.setProperty('--oddmi-wave-travel', travel + 'px');
      wave.style.setProperty('--oddmi-wave-duration', (travel / rate).toFixed(3) + 's');
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(sync, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('resize', onResize);
  window.addEventListener('load', sync);

  // Theme editor: re-measure when a section is added, moved, or its settings change.
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:reorder', sync);
})();
